import { render, staticRenderFns } from "./ratio.vue?vue&type=template&id=506c3665&scoped=true"
import script from "./ratio.vue?vue&type=script&lang=js"
export * from "./ratio.vue?vue&type=script&lang=js"
import style0 from "./ratio.vue?vue&type=style&index=0&id=506c3665&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c3665",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506c3665')) {
      api.createRecord('506c3665', component.options)
    } else {
      api.reload('506c3665', component.options)
    }
    module.hot.accept("./ratio.vue?vue&type=template&id=506c3665&scoped=true", function () {
      api.rerender('506c3665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BigNumber/ratio.vue"
export default component.exports